<template>
    <div>
        <br>
        <div align="center" :class="{  'h5': $vuetify.breakpoint.mdAndDown, 'h4': $vuetify.breakpoint.lgAndUp,  }">{{ $route.params.name != null ? $route.params.name : this.name }} - Quizzes</div>
        <v-container>
            <v-layout wrap>
                <v-flex ma-3 align-center justify-center xs12 md4 lg3>
                    <v-card align-center justify-center class="text-center">
                        <v-responsive class="pt-4">
                            <v-avatar tile size="80">
                                <v-img :src="require('../assets/quiz.png')"></v-img>
                            </v-avatar>
                        </v-responsive>
                        <v-card-title class="pa-2 justify-center">GUIDELINES</v-card-title>
                        <v-card-text>
                            <ul>
                                <li>Each Quiz containes 20 Questions.</li><br>
                                <li>Once a Quiz is started, the screen cannot go back until the Quiz is finished.</li><br>
                            </ul>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex align-center justify-center>
                    <v-layout v-for="quiz in quizes" :key="quiz.id">
                        <v-flex ma-2 align-center justify-center>
                            <router-link style="text-decoration: none; color: inherit;" :to="{ name: 'StartQuiz', params: { id2: quiz.qid, quizname: quiz.name } }">
                                <v-card class="py-0 my-0">
                                    <v-card-title class="pa-2 mx-5 my-0"  :class="{  'subtitle-2': $vuetify.breakpoint.mdAndDown, 'h5': $vuetify.breakpoint.lgAndUp,  }">
                                        <span>{{ quiz.name }}</span>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-chevron-right</v-icon>
                                    </v-card-title>
                                </v-card>
                            </router-link>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>



<script>
import db from '@/fb'

export default {
	name: 'test',
	data () {
		return {
            quizes: [],
            id: '',
			name: '',
			qid: ''
		}
    },
    created () {

          var id = this.$route.params.id ;
		var name =  this.$route.params.name ;
		//console.log(id);

			if(name == null){
			
			//console.log('Null hai');
				let ref = db.collection('Subjects').doc(id)
        		ref.get().then(
             snapshot => {
                if (snapshot.exists) {
                    var post = snapshot.data();	
					this.name = post['Name'];		
				
                } else {
                    console.log("No such document!");
                }     
             }
         )

		
        }
        
        db.collection('Subjects').doc(this.$route.params.id).collection('Quizes').orderBy('name').get().then(querySnapshot => {
            querySnapshot.forEach(doc =>{
                var todo = doc.data();
                todo.qid = doc.id;
                this.quizes.push(todo);
            })
        })
    }
}
</script>



<style lang="scss" scoped>

li {
    list-style-type: none;
}

// a {
//     text-decoration: none;
// }

// .lin {
//     text-decoration: none;
// }

ul {
    margin: 0;
    padding: 0;
}

</style>